import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'mercadoNome'
})
/** Pipe utilizado para exibir o nome do mercado */
export class MercadoNomePipe implements PipeTransform {

    /** Retorna o nome do mercado */
    transform(nome: string, codigoIntegracaoErp: string = null): string {
        let codigo = '';
        if (codigoIntegracaoErp) {
            codigo = `${codigoIntegracaoErp} - `;
        }
        return `${codigo}${nome}`;
    }
}
